import type { Deck } from '../../types';
import Cover from './slides/01-cover';
import WhatIsAso from './slides/02-what-is-aso';
import TheProblem from './slides/03-the-problem';
import TheSolution from './slides/04-the-solution';
import TheProduct from './slides/05-the-product';
import TheCustomerWin from './slides/06-the-customer-win';
import TheCustomer from './slides/07-the-customer';
import WhyNow from './slides/08-why-now';
import CompetitiveLandscape from './slides/09-competitive-landscape';
import MoatTechEdge from './slides/10-moat-tech-edge';
import Validation from './slides/11-validation';
import FoundersWhyUs from './slides/12-founders-why-us';
import ASOMarket from './slides/13-aso-market';
import TheWiderPlay from './slides/14-the-wider-play';
import BusinessModelUnitEconomics from './slides/15-business-model-unit-economics';
import Roadmap from './slides/16-roadmap';
import TheRaise from './slides/17-the-raise';
import CommonQuestions from './slides/A-common-questions';
import ToolConsolidation from './slides/B-tool-consolidation';
import CapitalEfficiency from './slides/C-capital-efficiency';
import Sources from './slides/D-sources';
import ExpansionPath from './slides/E-expansion-path';
import AiNativeFactory from './slides/F-ai-native-factory';
import TrustAndDataHandling from './slides/G-trust-and-data-handling';

export const seriesSeedPrimerV4: Deck = {
  slug: 'series-seed-primer-v4',
  title: 'Apptonomy — Pre-Seed Primer',
  slides: [
    {
      id: 'cover',
      title: 'Cover',
      Component: Cover,
      sectionBefore: 'Intro',
      stoplight: 'amber',
    },
    {
      id: 'what-is-aso',
      title: 'What is ASO',
      Component: WhatIsAso,
      stoplight: 'amber',
    },
    {
      id: 'the-problem',
      title: 'The Problem',
      Component: TheProblem,
      sectionBefore: 'Product',
      stoplight: 'amber',
    },
    {
      id: 'the-solution',
      title: 'The Solution',
      Component: TheSolution,
      stoplight: 'amber',
    },
    {
      id: 'the-product',
      title: 'The Platform',
      Component: TheProduct,
      stoplight: 'amber',
    },
    {
      id: 'the-customer-win',
      title: "Customer's Win",
      Component: TheCustomerWin,
      stoplight: 'amber',
    },
    {
      id: 'the-customer',
      title: 'The Customer',
      Component: TheCustomer,
      sectionBefore: 'Customer & Market',
      stoplight: 'amber',
    },
    { id: 'why-now', title: 'Why Now', Component: WhyNow, stoplight: 'amber' },
    {
      id: 'competitive-landscape',
      title: 'Competitive Landscape',
      Component: CompetitiveLandscape,
      stoplight: 'amber',
    },
    {
      id: 'moat-tech-edge',
      title: 'Moat / Tech Edge',
      Component: MoatTechEdge,
      stoplight: 'amber',
    },
    {
      id: 'validation',
      title: 'Validation',
      Component: Validation,
      stoplight: 'amber',
    },
    {
      id: 'founders-why-us',
      title: 'Why Us',
      Component: FoundersWhyUs,
      sectionBefore: 'Business',
      stoplight: 'amber',
    },
    {
      id: 'aso-market',
      title: 'The ASO Market',
      Component: ASOMarket,
      stoplight: 'amber',
    },
    {
      id: 'the-wider-play',
      title: 'The Wider Play',
      Component: TheWiderPlay,
      stoplight: 'amber',
    },
    {
      id: 'business-model-unit-economics',
      title: 'Economics',
      Component: BusinessModelUnitEconomics,
      stoplight: 'amber',
    },
    { id: 'roadmap', title: 'Roadmap', Component: Roadmap, stoplight: 'amber' },
    {
      id: 'the-raise',
      title: 'The Raise',
      Component: TheRaise,
      stoplight: 'amber',
    },
    {
      id: 'common-questions',
      title: 'Common Questions',
      Component: CommonQuestions,
      sectionBefore: 'Appendices',
    },
    {
      id: 'tool-consolidation',
      title: 'Tool Consolidation',
      Component: ToolConsolidation,
    },
    {
      id: 'capital-efficiency',
      title: 'The AI Arbitrage',
      Component: CapitalEfficiency,
    },
    { id: 'sources', title: 'Sources', Component: Sources },
    {
      id: 'expansion-path',
      title: 'Expansion Path',
      Component: ExpansionPath,
    },
    {
      id: 'ai-native-factory',
      title: 'AI-Native Factory',
      Component: AiNativeFactory,
    },
    {
      id: 'trust-and-data-handling',
      title: 'Trust & Data Handling',
      Component: TrustAndDataHandling,
    },
  ],
};
